import { render, staticRenderFns } from "./PayrollReport.vue?vue&type=template&id=058f6dcb&"
import script from "./PayrollReport.vue?vue&type=script&lang=js&"
export * from "./PayrollReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports